import PropTypes from 'prop-types';
import styles from './FJImageToImageLeft.module.less';
import FJGenerateQuantityContainer from '../FJGenerateQuantity/FJGenerateQuantityContainer';
import FJModalListContainer from '../FJModalList/FJModalListContainer';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJImageInputContainer from '../FJImageInput/FJImageInputContainer';
import FJPromptInputContainer from '../FJPromptInput/FJPromptInputContainer';
import { IMAGE_TO_IMAGE_USE_CREDIT } from '../../../redux/slices/FJSliceImageToImage';
import useDefaultFreeLimit from '../../../hooks/useDefaultFreeLimit.jsx';
import FJGeneratePrivacySettingsContainer from '../FJGeneratePrivacySettings/FJGeneratePrivacySettingsContainer.jsx';

const FJImageToImageLeft = props => {
    const {
        generateQuantity,
        onGenerate,
        taskStatus,
        isProjectLoading,
        freeNumCreation,
        creditNumber,
        isPro,
        isExpensive,
    } = props;
    const useCredit =
        generateQuantity * (isPro || isExpensive ? IMAGE_TO_IMAGE_USE_CREDIT * 2 : IMAGE_TO_IMAGE_USE_CREDIT);
    const isFree = freeNumCreation > 0 && useCredit > creditNumber && generateQuantity < 3 && !isPro && !isExpensive;

    const defaultFreeNumCreation = useDefaultFreeLimit();

    return (
        <FJAppLeft className={styles.container}>
            <FJImageInputContainer id='imageToImageInput' />
            <FJModalListContainer id='imageToImageList' />
            <div className={styles.footer}>
                <FJPromptInputContainer />
                <FJGenerateQuantityContainer />
                <FJGeneratePrivacySettingsContainer />
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    isShowUsageDetail={true}
                    id='imageToImageBtn'
                    defaultFreeNumCreation={defaultFreeNumCreation}
                    style={{ flex: 1 }}
                />
            </div>
        </FJAppLeft>
    );
};
export default FJImageToImageLeft;
FJImageToImageLeft.propTypes = {
    generateQuantity: PropTypes.number,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    isPro: PropTypes.bool,
    isExpensive: PropTypes.bool,
};
